module.exports = __webpack_public_path__ + "static/media/quiz5.16732441.png";